import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
	Typography,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	Button
} from '@material-ui/core'
import CurrentAverageCostOfLaborSummary from './CurrentAverageCostOfLaborSummary/CurrentAverageCostOfLaborSummary'
import CurrentAverageCostOfLaborDetail from './CurrentAverageCostOfLaborDetail/CurrentAverageCostOfLaborDetail'
import ProjectedAverageCostOfLaborDetail from './ProjectedAverageCostOfLaborDetail/ProjectedAverageCostOfLaborDetail'
import PerformanceRatingOrgDetail from './PerformanceRatingOrgDetail/PerformanceRatingOrgDetail'
import PerformanceRatingAndCompaRatioDetail from './PerformanceRatingAndCompaRatioDetail/PerformanceRatingAndCompaRatioDetail'
import ProjectedAverageCostOfLaborSummary from './ProjectedAverageCostOfLaborSummary/ProjectedAverageCostOfLaborSummary'
import PerformanceRatingOrgSummary from './PerformanceRatingOrgSummary/PerformanceRatingOrgSummary'
import PerformanceRatingAndCompaRatioSummary from './PerformanceRatingAndCompaRatioSummary/PerformanceRatingAndCompaRatioSummary'
import useStyles from './styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { downloadReportImage } from '../UtilityActions'
import { hasPermissions } from '../../../../helpers/AccessControl/AccessControl'

export default function Organization(props) {

	const classes = useStyles()

	const [expanded, setExpanded] = useState([])

	const handlePanelChange = (panelName) => {
		let expandedArray = [...expanded]
		if (expandedArray.includes(panelName)) {
			expandedArray.splice(expandedArray.indexOf(panelName), 1);
		} else {
			expandedArray.push(panelName)
		}
		setExpanded(expandedArray)
		localStorage.setItem('organization_open_reports', JSON.stringify(expandedArray))
	}

	useEffect(() => {
		if (localStorage.getItem('organization_open_reports') !== null) {
			let localWorkForceOpenReports = JSON.parse(localStorage.getItem('organization_open_reports'))
			setExpanded(localWorkForceOpenReports)
		}
	}, [])

	const downloadReportTableImage = (name) => {
		downloadReportImage(name, name)
	}

	return (
		<>
			{hasPermissions(['average_cost_labor_detail']) && <ExpansionPanel onChange={() => handlePanelChange('average_cost_labor_detail')} expanded={expanded.includes('average_cost_labor_detail')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Current Total & Average Cost of Labor Detail
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('CurrentAverageCostOfLaborDetailReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['CurrentAverageCostOfLaborDetail'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<CurrentAverageCostOfLaborDetail
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['CurrentAverageCostOfLaborDetail']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['CurrentAverageCostOfLaborDetail']}
						reportData={props.reportData['CurrentAverageCostOfLaborDetail']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						selectedCurrency={props.selectedCurrency}
						reportFiltersType={props.reportFiltersType['CurrentAverageCostOfLaborDetail']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['average_labor_cost_summary']) && <ExpansionPanel onChange={() => handlePanelChange('average_labor_cost_summary')} expanded={expanded.includes('average_labor_cost_summary')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Current Total & Average Cost of Labor Summary
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('CurrentAverageCostOfLaborSummaryReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['CurrentAverageCostOfLaborSummary'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<CurrentAverageCostOfLaborSummary
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['CurrentAverageCostOfLaborSummary']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['CurrentAverageCostOfLaborSummary']}
						reportData={props.reportData['CurrentAverageCostOfLaborSummary']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						selectedCurrency={props.selectedCurrency}
						reportFiltersType={props.reportFiltersType['CurrentAverageCostOfLaborSummary']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['projected_average_cost_labor_detail']) && <ExpansionPanel onChange={() => handlePanelChange('projected_average_cost_labor_detail')} expanded={expanded.includes('projected_average_cost_labor_detail')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Projected Average Cost of Labor Detail
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('ProjectedAverageCostOfLaborDetailReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['ProjectedAverageCostOfLaborDetail'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<ProjectedAverageCostOfLaborDetail
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['ProjectedAverageCostOfLaborDetail']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['ProjectedAverageCostOfLaborDetail']}
						reportData={props.reportData['ProjectedAverageCostOfLaborDetail']}
						onApply={props.onApply}
						forecastOptions={props.forecastOptions}
						selectedForecast={props.selectedForecasts['organizationProjectedDetails']}
						forecastSelectionChanged={props.forecastSelectionChanged}
						resetFilter={props.resetFilter}
						availableColumns={props.availableColumns}
						selectedCurrency={props.selectedCurrency}
						reportFiltersType={props.reportFiltersType['ProjectedAverageCostOfLaborDetail']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['projected_average_cost_labor_summary']) && <ExpansionPanel onChange={() => handlePanelChange('projected_average_cost_labor_summary')} expanded={expanded.includes('projected_average_cost_labor_summary')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Projected Average Cost of Labor Summary
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('AverageCostOfLaborSummaryReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['ProjectedAverageCostOfLaborSummary'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<ProjectedAverageCostOfLaborSummary
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['ProjectedAverageCostOfLaborSummary']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['ProjectedAverageCostOfLaborSummary']}
						reportData={props.reportData['ProjectedAverageCostOfLaborSummary']}
						onApply={props.onApply}
						forecastOptions={props.forecastOptions}
						selectedForecast={props.selectedForecasts['organizationProjectedSummary']}
						forecastSelectionChanged={props.forecastSelectionChanged}
						resetFilter={props.resetFilter}
						availableColumns={props.availableColumns}
						selectedCurrency={props.selectedCurrency}
						reportFiltersType={props.reportFiltersType['ProjectedAverageCostOfLaborSummary']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['performance_rating_org_detail']) && <ExpansionPanel onChange={() => handlePanelChange('performance_rating_org_detail')} expanded={expanded.includes('performance_rating_org_detail')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Performance Rating Org Detail
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('PerformanceRatingOrgDetailReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['PerformanceRatingOrgDetail'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<PerformanceRatingOrgDetail
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['PerformanceRatingOrgDetail']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['PerformanceRatingOrgDetail']}
						reportData={props.reportData['PerformanceRatingOrgDetail']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						availableColumns={props.availableColumns}
						reportFiltersType={props.reportFiltersType['PerformanceRatingOrgDetail']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['performance_rating_org_summary']) && <ExpansionPanel onChange={() => handlePanelChange('performance_rating_org_summary')} expanded={expanded.includes('performance_rating_org_summary')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Performance Rating Org Summary
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('PerformanceRatingOrgSummaryReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['PerformanceRatingOrgSummary'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<PerformanceRatingOrgSummary
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['PerformanceRatingOrgSummary']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['PerformanceRatingOrgSummary']}
						reportData={props.reportData['PerformanceRatingOrgSummary']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						availableColumns={props.availableColumns}
						reportFiltersType={props.reportFiltersType['PerformanceRatingOrgSummary']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['performance_rating_org_compa_ratio_detail']) && <ExpansionPanel onChange={() => handlePanelChange('performance_rating_org_compa_ratio_detail')} expanded={expanded.includes('performance_rating_org_compa_ratio_detail')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Performance Rating and Compa-Ratio Detail
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('PerformanceRatingAndCompaRatioDetailReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['PerformanceRatingAndCompaRatioDetail'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<PerformanceRatingAndCompaRatioDetail
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['PerformanceRatingAndCompaRatioDetail']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['PerformanceRatingAndCompaRatioDetail']}
						reportData={props.reportData['PerformanceRatingAndCompaRatioDetail']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						availableColumns={props.availableColumns}
						reportFiltersType={props.reportFiltersType['PerformanceRatingAndCompaRatioDetail']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['performance_rating_org_compa_ratio_summary']) && <ExpansionPanel onChange={() => handlePanelChange('performance_rating_org_compa_ratio_summary')} expanded={expanded.includes('performance_rating_org_compa_ratio_summary')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Performance Rating and Compa-Ratio Summary
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('PerformanceRatingAndCompaRatioSummaryReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['PerformanceRatingAndCompaRatioSummary'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<PerformanceRatingAndCompaRatioSummary
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['PerformanceRatingAndCompaRatioSummary']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['PerformanceRatingAndCompaRatioSummary']}
						reportData={props.reportData['PerformanceRatingAndCompaRatioSummary']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						availableColumns={props.availableColumns}
						reportFiltersType={props.reportFiltersType['PerformanceRatingAndCompaRatioSummary']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
		</>
	)
}

Organization.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.object.isRequired,
	onApply: PropTypes.func.isRequired,
	forecastOptions: PropTypes.array.isRequired,
	selectedForecasts: PropTypes.object.isRequired,
	forecastSelectionChanged: PropTypes.func.isRequired,
}
